import React from "react";

const InputField = ({ label, name, options, value, onChange }) => {
  return (
    <div className="flex flex-col">
      <label className="mb-1  text-sky-200 font-semibold">{label}</label>
      <select
        value={value}
        onChange={(e) => onChange(name, e.target.value)}
        className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 "
        required
      >
        <option value="">Select {label}</option>
        {options.map((opt, idx) => (
          <option key={idx} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </div>
  );
};

export default InputField;
